export const ComercioSingleData =
{
    "id": 1,
    "image_url": "http://lorempixel.com/100/100/food/",
    "name": "Carnes de Res 1",
    "categoria": "Carniceria",
    "descripcion": "Cárnicas Sedano, S.A. es una empresa familiar que nació hace más de 60 años. Fue fundada por Don Eliseo Sedano que ya en 1940 comenzó como tratante de ganado, eligiendo y distribuyendo las mejores carnes para las empresas cárnicas de la ciudad.",
    "direccion": "Riobamba 512, ABL, Buenos Aires, Argentina",
    "distancia": 400,
    "calificacion": 4
}
